import React from 'react';

const EqualOpportunitiesSection = () => (
  <section id="equal-opportunities" className="relative z-10 -mt-16 md:-mt-24 pb-24 px-4">
    <div className="max-w-5xl mx-auto bg-white border border-[#f4e7da] shadow-[0_25px_65px_rgba(16,24,40,0.08)] rounded-[22px] overflow-hidden">
      <div className="px-6 md:px-12 py-12 md:py-16 space-y-10 text-[#4c4c4c] leading-relaxed">
        <div className="text-center space-y-4">
          <p className="text-xs uppercase tracking-[0.45em] text-[#2f4c74]">Our commitment</p>
          <h2
            className="text-3xl md:text-4xl font-light text-[#0d0d0d]"
            style={{ fontFamily: "'Playfair Display', 'Times New Roman', serif" }}
          >
            Equal Opportunities Policy
          </h2>
          <p>
            Everyone deserves to feel welcomed, respected and supported. This policy explains how we remove barriers for
            our teams and the young people who call Testa Care home.
          </p>
        </div>

        <article className="space-y-4">
          <h3 className="text-2xl font-light text-[#2f4c74]">Employees</h3>
          <p>
            The organisation wholeheartedly supports the principle of equal opportunities in employment and opposes all
            forms of unlawful discrimination on the grounds of age, disability, gender reassignment, marriage and civil
            partnership, pregnancy and maternity, race, religion or belief, sex or any other protected characteristics. The
            same commitment applies to the way we treat former employees, visitors, clients, customers and suppliers.
          </p>
          <p>
            We believe it is in everyone's best interests to make full use of the talents available within our communities.
            Within the framework of the law we aim, wherever practicable, to achieve a workforce that reflects the local
            community we serve.
          </p>
          <p>
            Every step is taken to ensure individuals are treated fairly and that recruitment, selection, training,
            promotion and career management decisions are based on objective, job-related criteria.
          </p>
          <p>
            When recruiting and retaining employees with disabilities we draw on best-practice guidance and, where needed,
            seek advice from specialist agencies and the Employment Service so that reasonable adjustments are made
            quickly.
          </p>
        </article>

        <article className="space-y-4">
          <h3 className="text-2xl font-light text-[#2f4c74]">Young people</h3>
          <p>
            Testa Care welcomes every young person and does not discriminate on the basis of race or ethnic origin, creed,
            colour, religion, disability or impairment, gender or sexual orientation. Every child is treated as an
            individual with unique needs, including any additional educational needs.
          </p>
          <p>
            Daily routines, enrichment activities and school support plans are designed to champion equal opportunities.
            We adapt activities and environments to accommodate disabilities or impairments so that all needs are met with
            dignity.
          </p>
          <p>
            Each residential home provides inclusive resources, celebrates customs and festivals from different religions
            and ethnic backgrounds, and promotes an ethos of equality so young people can develop non-judgmental attitudes.
          </p>
          <p>
            Catering plans recognise individual dietary requirements, and staff training includes awareness of food
            traditions that may be prohibited by different faiths or cultures.
          </p>
          <p>
            We support the right of every young person, their families, our staff and professional partners to live free
            from prejudice and abuse. The team actively challenges discrimination in all its forms.
          </p>
        </article>
      </div>
    </div>
  </section>
);

export default EqualOpportunitiesSection;
